<template>
  <Panel
    class="scores d-flex align-items-center justify-content-around p-0"
    :variant="scoresVariant"
  >
    <input
      v-if="editMode"
      v-model.number="score.player_1_scored"
      class="scores_input hide-arrows"
      type="number"
      :disabled="allowPlayerEnterResults"
      maxlength="inputMaxLength"
      @input="handleInput($event, 'player_1_scored')"
      @wheel="preventScroll($event)"
      @keydown="preventArrowKeys($event)"
    />
    <span
      v-else
      class="scores_item mx-1"
      :class="{
        'text-secondary': !hasValue(score.player_1_scored),
      }"
      >{{ hasValue(score.player_1_scored) || defaultValues[0] }}</span
    >
    <template v-if="!compactMode">
      <span class="mx-5">{{ separator }}</span>
      <input
        v-if="editMode"
        v-model.number="score.player_2_scored"
        class="scores_input hide-arrows"
        type="number"
        :disabled="allowPlayerEnterResults"
        maxlength="inputMaxLength"
        @input="handleInput($event, 'player_2_scored')"
        @wheel="preventScroll($event)"
        @keydown="preventArrowKeys($event)"
      />
      <span
        v-else
        class="scores_item mx-1"
        :class="{
          'text-secondary': !hasValue(score.player_2_scored),
        }"
        >{{ hasValue(score.player_2_scored) || defaultValues[1] }}</span
      >
    </template>
  </Panel>
</template>

<script>
import Panel from '@/components/atoms/Panel';
import { SCORE_SEPARATOR } from '@/constants/battles';

export default {
  name: 'Scores',
  components: {
    Panel,
  },
  model: {
    event: 'update',
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    compactMode: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    inputMaxLength: {
      type: Number,
      default: 2,
    },
    separator: {
      type: String,
      default: SCORE_SEPARATOR,
    },
    defaultValues: {
      type: Array,
      default: () => ['', ''],
    },
    allowPlayerEnterResults: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      SCORE_SEPARATOR,
    };
  },
  computed: {
    score() {
      return this.value;
    },
    scoresVariant() {
      const strokeVariant = this.errors.length
        ? ['stroked', 'stroked-error']
        : ['stroked', 'stroked-secondary'];
      return ['transparent', 'rounded-medium', ...strokeVariant];
    },
  },
  methods: {
    hasValue(score) {
      return Number.isInteger(score) || score === 'Win' || score === 'Lose'
        ? score.toString()
        : false;
    },

    handleInput(event, field) {
      const inputValue = event.target.value;
      const numericValue = inputValue.replace(/[^0-9]/g, '');
      event.target.value = numericValue;
      this.score[field] =
        numericValue === '' ? null : parseInt(numericValue, 10);
      this.$emit('update', this.score);
    },

    preventScroll(event) {
      event.preventDefault();
    },
    preventArrowKeys(event) {
      if (event.key.startsWith('Arrow')) {
        event.preventDefault();
      }
    },
  },
};
</script>
<style lang="scss">
.scores {
  .scores_item,
  input[type='number'] {
    height: 28px;
    width: 38px;
    padding: 5px;
    border: none;
    text-align: center;
    background-color: transparent;
    color: white;
    outline: none;
  }

  &.editable {
    display: block;
    background-color: transparent;
    overflow: hidden;
  }
  &_item {
    line-height: 1.2;
    .error & {
      color: $ph-error;
    }
  }
  .bold & {
    font-weight: 500;
  }
  .lh-30 {
    line-height: 30px;
  }
  &:focus-within {
    border-color: $ph-accent !important;
  }
}
</style>
